// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-text[data-v-fd1c8402]{font-size:12px}.title-price[data-v-fd1c8402]{text-align:left}.border-dashed[data-v-fd1c8402]{border-style:dashed;opacity:.4}", ""]);
// Exports
module.exports = exports;
